import { bindPrototypeMethodsToSelf } from '@wix/panorama-common/utils';
import type { TransactionUserData } from '@wix/panorama-common-shared/types';
import {
  type CustomTransactionName,
  isCustomTransactionName,
} from '@wix/panorama-common-shared/utils';
import { type BasePanoramaClient } from './panorama-client-base';
import type { TransactionOptions } from './types';
import { defaults } from './utils/general-utils';

export interface PanoramaTransaction {
  start: (data?: TransactionUserData, options?: TransactionOptions) => void;
  finish: (data?: TransactionUserData, options?: TransactionOptions) => void;
}

export class PanoramaTransactionImpl implements PanoramaTransaction {
  constructor(
    private readonly baseClient: BasePanoramaClient,
    private readonly name: CustomTransactionName<string>,
    private readonly options?: TransactionOptions,
  ) {
    if (!isCustomTransactionName(name)) {
      throw new Error(`"${name}" is an internal transaction and can't be used`);
    }

    this.baseClient = baseClient;

    bindPrototypeMethodsToSelf(this);
  }

  start(data?: TransactionUserData, options?: TransactionOptions) {
    return this.baseClient.reportTransactionStart(
      this.name,
      defaults(options, this.options),
      data,
    );
  }

  finish(data?: TransactionUserData, options?: TransactionOptions) {
    return this.baseClient.reportTransactionFinish(
      this.name,
      defaults(options, this.options),
      data,
    );
  }
}
